export default function () {
  return {
    errors: {},
    validFromMenu: false,
    validUntilMenu: false,
    formattedValidFrom: null,
    formattedValidUntil: null,
    coupon: {
      code: '',
      type: 0,
      enabled: true,
      validFrom: null,
      validUntil: null,
      plans: [],
      maxUsage: 0,
      usesPerUser: 0,
    },
    plansList: [],
    loadingPlans: false,
    planSearchQuery: '',
    teachersList: [],
    loadingTeachers: false,
    teacherSearchQuery: '',
  }
}
